// src/core/adapters/LondonArrivalsBoardStops.js
//
// Stop list preparation for the arrivals board. Client-specific
// curtailed stop sets are keyed by contract line + stop code.

import { sortStops } from './LondonDataSort';

export const STOP_FILTER_MODES = {
  ALL: 'all',
  TIMING: 'timing',
  CURTAIL: 'curtail',
};

// Composite key for a stop within a route. Used by the curtailment set.
export const makeStopKey = (contractLineNo, stopCodeLbsl) =>
  `${contractLineNo}::${stopCodeLbsl}`;

// Predicate for whether a stop should appear under the given mode.
export const filterStop = (stop, mode, curtailStopSet, contractLineNo) => {
  if (mode === STOP_FILTER_MODES.TIMING) {
    return !!stop.timing_point_code;
  }
  if (mode === STOP_FILTER_MODES.CURTAIL) {
    if (!curtailStopSet || !contractLineNo) return false;
    return curtailStopSet.has(makeStopKey(contractLineNo, stop.stop_code_lbsl));
  }
  return true;
};

// Sorted + filtered stop list for the board.
export const getBoardStops = (stops, mode, curtailStopSet, contractLineNo) => {
  return sortStops(stops).filter(stop =>
    filterStop(stop, mode, curtailStopSet, contractLineNo)
  );
};